module.exports = __webpack_public_path__ + "static/media/SentTestingIcon.b1e1796d.svg";